import Button from "@material-ui/core/Button";
import React, { Component } from "react";
import Select from "react-select";
import { instance } from "../../../Actions/AxiosInstance";
import InputValues from "../../../Component/InputValues";
import "./index.css";

export default class DevicePingAlert extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hours: 1,
      fullname: "",
      selectedemployee: null,
      errorfullname: false,
      errorhours: false,
      open: false,
      edit: true,
    };

    this.handleChange = this.handleChange.bind(this);
    this.onClickAway = this.onClickAway.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onCloseDrawer = this.onCloseDrawer.bind(this);
    this.conFirmDelete = this.conFirmDelete.bind(this);
  }

  handleChange(name, type, e) {
    const errorname = `error${name}`;
    if (type == "select") {
      if (e && e.length > 0) {
        this.setState({
          [errorname]: false,
          selectedemployee: e,
        });
      } else {
        this.setState({
          [errorname]: true,
          selectedemployee: null,
        });
      }
    } else if (type == "number") {
      if (Number.isNaN(e.target.value)) {
        this.setState({
          [errorname]: true,
          [name]: e.target.value,
        });
      } else {
        this.setState({
          [errorname]: false,
          [name]: e.target.value,
        });
      }
    }
  }

  searchEmployee = (search) => {
    if (search.length < 3) return;
    if (
      (!this.state.prevSearch || this.state.prevSearch != search) &&
      search.length >= 3
    ) {
      const URL = `/subscription/employeelist`;
      const data = {
        searchfor: search,
        statusid: 1,
        featurekey: "biometric",
      };
      instance
        .post(URL, data)
        .then((result) => {
          this.setState({ emplist: result.data.result });
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  };

  onClickAway() {
    this.setState({
      menuopen: false,
    });
  }

  onEdit() {
    const emps =
      this.props.pingalerts.employeejson &&
      this.props.pingalerts.employeejson.map((emp) => ({
        displayname: emp.fullname,
        displayvalue: emp.employeeid,
      }));
    this.setState({
      hours: this.props.pingalerts.offlineinterval,
      selectedemployee: emps,
      edit: true,
    });
  }

  conFirmDelete() {
    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",
      action: [
        <Button
          color="inherit"
          size="small"
          onClick={() => this.onDelete(this.props.pingalerts.devicealertid)}
        >
          Yes
        </Button>,
        <Button color="inherit" size="small">
          No
        </Button>,
      ],
    });
  }

  onDelete(id) {
    instance.delete(`biometric/getdevicealert/${id}`).then(
      (result) => {
        this.props.closeDrawer();
      },
      (error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      },
    );
  }

  onSave() {
    if (
      this.state.hours == "" ||
      this.state.selectedemployee == null ||
      this.state.selectedemployee.length < 1
    ) {
      this.props.enqueueSnackbar("Please fill all fields", {
        variant: "error",
      });
    } else {
      const data = {
        biometricdeviceid: this.props.pingalerts.id,
        offlineinterval: this.state.hours,
        employeeids: this.state.selectedemployee.map((emp) => emp.displayvalue),
        devicealertid: this.state.edit
          ? this.props.pingalerts.devicealertid
          : null,
      };
      instance
        .post("biometric/createdevicealert", data)
        .then((result) => {
          this.setState({
            edit: false,
          });
          this.props.enqueueSnackbar("saved successfully", {
            variant: "success",
          });
          this.props.closeDrawer();
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  onCloseDrawer() {
    this.props.closeDrawer();
  }

  render() {
    return (
      <div>
        <div className="formwrapper" tabIndex="1">
          <span className="drawer-cancle-btn">
            <svg
              onClick={this.onCloseDrawer}
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z" />
            </svg>
          </span>
          <p className="title">Device Ping Alerts</p>
          <p className="subtitle">Add Alert</p>
          <div className="">
            <p className="form-input-label">
              Device must be offline for a minimum
            </p>
            <InputValues
              min="1"
              max="24"
              field="lapsedays"
              defaultvalue={1}
              onChange={(e) => this.handleChange("hours", "number", e)}
              value={this.state.hours}
            />
            <span className="label">hours</span>
          </div>
          <div>
            <p className="label">Employee Names</p>
            <Select
              isMulti
              className="input3"
              onInputChange={this.searchEmployee}
              onChange={(e) => this.handleChange("fullname", "select", e)}
              options={this.state.emplist}
              getOptionLabel={(option) => option.displayname}
              getOptionValue={(option) => option.displayvalue}
              value={this.state.selectedemployee}
            />
          </div>
          <div>
            <Button className="addbutton" onClick={this.onSave}>
              ADD
            </Button>
          </div>

          <div className="margin-top-16 margin-bottom-16">
            <div className="floatleft">
              <p className="subtitle">Alerts Created</p>
            </div>
            <div className="floatright">
              <span className="cursor-pointer" onClick={this.onEdit}>
                <i className="material-icons edit-authority-icon">edit</i>
              </span>
              <span className="cursor-pointer" onClick={this.conFirmDelete}>
                <i className="material-icons delete-authority-icon">delete</i>
              </span>
            </div>
          </div>
          <div style={{ clear: "both" }}></div>
          <div>
            <ul className="list">
              <li className="columlist1">
                <div>
                  <p className="form-sub-header">Name</p>
                </div>
              </li>
              <li className="columlist2">
                <div>
                  <p className="form-sub-header">Contact Details</p>
                </div>
              </li>
            </ul>
            {this.props.pingalerts &&
              this.props.pingalerts.employeejson &&
              this.props.pingalerts.employeejson.length > 0 &&
              this.props.pingalerts.employeejson.map((contact) => (
                <ul className="list">
                  <li className="columlist1">
                    <div>{contact.fullname}</div>
                  </li>
                  <li className="columlist2">
                    <div className="innertext1">
                      <div className="innertextchild1">
                        {contact.emailid}
                        <div>{contact.primarymobile}</div>
                      </div>
                    </div>
                  </li>
                </ul>
              ))}
          </div>
        </div>
      </div>
    );
  }
}
